import { formatDate } from "_helper/utils";
import { FORM_ERROR_MESSAGES } from "Constant";
import { TRANG_THAI, TRANG_THAI_VALUES } from "pages/theo-doi-vi-pham/constant";
import { TableColumn } from "react-data-table-component";
import { UseFormReturn } from "react-hook-form";
import { Badge } from "reactstrap";

export const useListTableColumns = () => {
  const tableColumns: TableColumn<any>[] = [
    {
      name: "Loại vi phạm",
      selector: ({ cccd }) => cccd || "",
    },
    {
      name: "Trạng thái",
      selector: ({ trangThai }) => (
        <Badge
          color={trangThai === TRANG_THAI.HOAN_THANH ? "success" : "danger"}
        >
          {TRANG_THAI_VALUES[trangThai]}
        </Badge>
      ),
    },
    {
      name: "Ngày giờ",
      selector: ({ ngaySinh }) => formatDate(ngaySinh),
    },
    {
      name: "Địa chỉ",
      selector: ({ diaChi }) => diaChi || "",
    },
    {
      name: "Người tạo",
      selector: ({ nguoiTao }) => nguoiTao || "",
    },
    {
      name: "Người chỉnh sửa",
      selector: ({ nguoiChinhSua }) => nguoiChinhSua || "",
    },
  ];
  return { tableColumns };
};

export const useFormFields = (useFormReturn?: UseFormReturn) => {
  return [
    {
      name: "cccd",
      label: "Loại vi phạm",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "ngaySinh",
      label: "Ngày xảy ra vi phạm",
      type: "date",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "moTaViPham",
      label: "Mô tả",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "ngayLapHoSo",
      label: "Ngày lập hồ sơ",
      type: "date",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "nguoiTao",
      label: "Cán bộ lập hồ sơ",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "soQuyetDinhXuPhat",
      label: "Số quyết định xử phạt",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "soTienPhat",
      label: "Số tiền phạt",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
    {
      name: "trangThai",
      label: "Trạng thái xử phạt",
      type: "input",
      rules: {
        required: FORM_ERROR_MESSAGES.REQUIRED,
      },
    },
  ].flat() as any;
};

export const title = "Danh Sách hồ sơ vi phạm";
export const parent = "Hồ sơ vi phạm";
